;(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  const initializeBlock = function () {
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.childNodes[0].childNodes[0].classList.remove('translate-y-10')
          entry.target.childNodes[0].childNodes[0].classList.remove('opacity-0')
          entry.target.childNodes[0].childNodes[0].classList.add('opacity-50')
          entry.target.childNodes[0].childNodes[1].classList.remove('translate-y-10')
          entry.target.childNodes[0].childNodes[1].classList.remove('opacity-0')
          entry.target.childNodes[0].childNodes[2].classList.remove('translate-y-10')
          entry.target.childNodes[0].childNodes[2].classList.remove('opacity-0')
          entry.target.childNodes[0].childNodes[2].classList.add('opacity-70')
          entry.target.childNodes[1].classList.remove('scale-0')

          observer.unobserve(entry.target)
        }
      })
    }

    const options = {rootMargin: '-20%'}

    const myObserver = new IntersectionObserver(callback, options)

    const usps = document.querySelectorAll('.usp')

    usps.forEach(usp => {
      myObserver.observe(usp)
    });
  }

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeBlock()
  })

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=usps', initializeBlock)
  }
})(jQuery)
